<template>
  <el-card>
    <el-row class="auto-message__title">策略系统</el-row>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="策略内容库" name="first">
        <StrategyContentLibrary :strategyTypeList="strategyTypeList" :channelList="channelList" :langList="langList"
          :options="options" @update:options="updateOptions" />
      </el-tab-pane>
      <el-tab-pane label="策略列表" name="third">
        <StrategySystem :strategyTypeList="strategyTypeList" :channelList="channelList" :countryList="countryList"
          :options="options" @edit-trigger="handleEditTrigger" @change-trigger="handleChangeTrigger"
          @delete-trigger="handleDeleteTrigger" />
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import StrategyContentLibrary from '@/components/StrategyContentLibrary.vue'
import StrategySystem from '@/components/StrategySystem.vue'

export default {
  components: {
    StrategyContentLibrary,
    StrategySystem,
  },
  data() {
    return {
      activeName: 'first',
      // 策略类型列表
      strategyTypeList: [],
      // 渠道列表
      channelList: [],
      // 语言列表
      langList: [],
      // 国家列表
      countryList: [],
      // 分类后自动消息列表
      options: [],
    }
  },
  mounted() {
    this.getChannel()
    this.getMessageGroup()
    this.getLang()
    this.getCountryCode()
  },
  methods: {
    updateOptions(newOptions) {
      this.options = newOptions
    },
    handleEditTrigger({ data, type }) {
      // 处理编辑触发策略的逻辑
      console.log('编辑触发策略:', data, type)
    },
    handleChangeTrigger(data) {
      // 处理状态变更的逻辑
      console.log('状态变更:', data)
    },
    handleDeleteTrigger(id) {
      // 处理删除的逻辑
      console.log('删除触发策略:', id)
    },
    //获取策略类型
    async getMessageGroup() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.const_all,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          className: 'com.quhong.constant.AutoMessageStrategyType',
        },
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.strategyTypeList = res.data
      }
    },
    //获取渠道选项
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelList = [
          { channelId: -1, name: 'all', value: 'all' },
          ...res.data,
        ]
      }
    },
    //获取国家选项
    async getCountryCode() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.normal_country +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.countryList = res.data.countryList
      }
    },
    //获取语言
    async getLang() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.langList,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.langList = res.data
      }
    },
  }
}
</script>

<style scoped lang="scss">
.auto-message {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }
}
</style>
